import { Page, Panel } from "layouts/finance/shared";
import SetChargesTable from "./charge-table";
export default function MerchantPrice() {
  return (
    <Page
      title="Merchant charges"
      description="Manage existing merchant collection charges and fee agreements."
    >
      <Panel>
        <SetChargesTable />
      </Panel>
    </Page>
  );
}
